import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "@env/environment";
import { ServiceVisit } from "../models/service-visit.model";

export interface ServiceVisitPayload {
  tenantId: string;
  serviceDetailId: string;
}

@Injectable({ providedIn: "root" })
export class ServiceVisitService {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${environment.API_SERVICES}`;

  async getServiceVisits(payload: ServiceVisitPayload): Promise<ServiceVisit[]> {
    const response = await firstValueFrom(
      this.http.get<ServiceVisit[]>(
        `${this.endpoint}/api/customer-care/v1/${payload.tenantId}/visit/${payload.serviceDetailId}`,
      ),
    );

    return response || [];
  }
}
